import React from "react";
import { Helmet } from "react-helmet-async";
import "./AboutUs.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

const AboutUs = () => {
  return (
    <>
      {/* ================= SEO META TAGS ================= */}
      <Helmet>
        <title>Health Care Diagnostic Center in Mohali – Kior Healthcare</title>

        <meta
          name="description"
          content="Kior Healthcare is a trusted health care diagnostic center in Mohali offering pathology, imaging, ultrasound, scan services, and a reliable hospital laboratory near you."
        />

        <meta
          name="keywords"
          content="Health Care Diagnostic Center in Mohali, Ultrasound Centre in Mohali, Hospital Laboratory Near Me, Scan Centre, Sonography Clinic"
        />

        <meta
          property="og:title"
          content="Kior Healthcare – Health Care Diagnostic Center in Mohali"
        />
        <meta
          property="og:description"
          content="Advanced pathology and imaging diagnostics including ultrasound, CT scan, and laboratory services in Mohali."
        />
        <meta property="og:type" content="website" />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* ================= BANNER ================= */}
      <section className="banner-section">
        <div className="banner_img">
          <img
            src="/images/aboutUs.jpeg"
            alt="Kior Healthcare Diagnostic Center Mohali"
            className="img-fluid w-100"
          />
        </div>
      </section>

      {/* ================= BREADCRUMB ================= */}
      <section className="brudcrum-sec py-3">
        <div className="coustom_container">
          <div className="aboutus_brudcrums d-flex align-items-center gap-2 flex-wrap">
            <Link
              to="/"
              className="previous_pg d-flex align-items-center text-decoration-none text-dark"
            >
              <ArrowBackIosIcon fontSize="small" />
              <span>Home</span>
            </Link>
            <span>/</span>
            <Link to="/about-us" className="text-decoration-none text-primary">
              <span>About Us</span>
            </Link>
          </div>
        </div>
      </section>

      {/* ================= ABOUT DESCRIPTION ================= */}
      <section className="about_description py-5">
        <div className="coustom_container">
          <h1 className="mb-3">
            Kior Healthcare – Leading Health Care Diagnostic Center in Mohali
          </h1>

          <p>
            <strong>Kior Healthcare</strong> is committed to delivering accurate,
            reliable, and patient-centric diagnostic services. As a premier
            <strong> health care diagnostic center in Mohali</strong>, we merge
            advanced technology with skilled medical professionals to provide
            comprehensive healthcare diagnostics.
          </p>

          <p>
            Our mission is to make diagnostics accessible, precise, and
            convenient for individuals across Mohali and nearby regions,
            enabling informed medical decisions and better health outcomes.
          </p>

          <h4 className="mt-4">Who We Are</h4>
          <p>
            We are a modern diagnostic facility offering a complete range of
            laboratory and imaging services. Our
            <strong> hospital laboratory near me</strong> is equipped with
            state-of-the-art analyzers and follows stringent quality standards
            to ensure dependable results.
          </p>

          <p>
            Kior Healthcare also operates as a trusted
            <strong> ultrasound centre in Mohali</strong>, offering prenatal,
            gynecological, and general sonography with a strong focus on safety,
            comfort, and diagnostic accuracy.
          </p>

          <h4 className="mt-4">Our Services</h4>
          <Row className="mt-3">
            <Col md={6}>
              <h6>Pathology & Laboratory Services</h6>
              <ul>
                <li>Comprehensive blood tests</li>
                <li>Hormonal analysis</li>
                <li>Organ function testing</li>
                <li>Preventive health packages</li>
                <li>Specialized panels for diabetes, thyroid & anemia</li>
              </ul>
            </Col>

            <Col md={6}>
              <h6>Imaging & Scan Services</h6>
              <ul>
                <li>X-Ray and CT Scan (Scan Centre)</li>
                <li>Ultrasound & Sonography (Sonography Clinic)</li>
                <li>Digital radiology solutions</li>
                <li>Prenatal & gynecological imaging</li>
              </ul>
            </Col>
          </Row>

          <h4 className="mt-4">Why Choose Kior Healthcare?</h4>
          <ul>
            <li>Accurate and reliable reports using advanced technology</li>
            <li>Complete diagnostic solutions under one roof</li>
            <li>Experienced technicians and medical professionals</li>
            <li>Fast reports with digital access</li>
            <li>Trusted ultrasound and scan services in Mohali</li>
            <li>Conveniently located hospital laboratory near you</li>
          </ul>

          <p className="mt-3">
            At Kior Healthcare, we are dedicated to providing diagnostic services
            patients can trust—supporting your health journey with precision,
            care, and compassion.
          </p>
        </div>
      </section>

      {/* ================= VISION & MISSION ================= */}
      <section className="aboutUs_vision_mission py-5">
        <div className="coustom_container">
          <Row className="gy-4">
            <Col md={6}>
              <div className="aboutus_vision text-center">
                <img
                  src="/images/OUR-VISION-icon.webp"
                  alt="Vision"
                  className="mb-3"
                />
                <h4 className="fw-bold">OUR VISION</h4>
                <p>
                  To be the most trusted and patient-friendly diagnostic center
                  in Mohali, recognized for quality, innovation, and compassion.
                </p>
              </div>
            </Col>

            <Col md={6}>
              <div className="aboutus_mission text-center">
                <img
                  src="/images/OUR-MISSION-icon.webp"
                  alt="Mission"
                  className="mb-3"
                />
                <h4 className="fw-bold">OUR MISSION</h4>
                <p>
                  To deliver timely, accurate, and accessible diagnostic
                  services using advanced technology and expert care to empower
                  better medical decisions.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* ================= TEAM ================= */}
      <section className="our_team py-5 bg-primary">
        <div className="coustom_container">
          <Row className="align-items-center">
            <Col md={4} className="text-center">
              <img
                src="/images/ourteam_img.png"
                alt="Kior Healthcare Team"
                className="img-fluid"
              />
            </Col>

            <Col md={8} className="text-white">
              <h1>Our Team</h1>
              <p>
                Kior Healthcare is powered by experienced pathologists,
                radiologists, technicians, and phlebotomists trained at premier
                institutes like PGI. Our interdisciplinary team works together
                to ensure accuracy, safety, and excellence in diagnostics.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      {/* ================= VALUES ================= */}
      <section className="values_section py-5">
        <div className="text-center mb-4">
          <h1>Our Values</h1>
        </div>

        <div className="coustom_container">
          <Row className="gy-4">
            {[
              ["C", "COLLABORATION", "Working together to deliver excellence"],
              ["A", "AGILITY", "Adapting quickly with innovative diagnostics"],
              ["R", "RESPECT", "Treating every patient with dignity"],
              ["E", "EMPATHY", "Caring deeply about patient well-being"],
              ["S", "OWNERSHIP", "Taking responsibility for quality and trust"],
            ].map(([l, t, d], i) => (
              <Col md={4} sm={6} key={i}>
                <div className="alphabet_card text-center p-4 shadow h-100">
                  <h1>{l}</h1>
                  <h6>{t}</h6>
                  <p>{d}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
